import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../context/SocketContext";
import {
  getTicketDetailFromStorage,
  setTicketDetailInStorage,
  TicketDetail,
} from "../../utils/ticket";

const formatLastNameAsInitial = (lastName?: string | null) => {
  if (!lastName) return lastName;

  const trimmed = lastName.trim();
  if (!trimmed) return lastName;

  const parts = trimmed.split(/\s+/);
  const last = parts[parts.length - 1];
  if (!last) return lastName;

  const initial = last.charAt(0).toUpperCase();
  return `${initial}.`;
};

const MagicScreen = () => {
  const [latestStatus, setLatestStatus] = useState("");

  const navigate = useNavigate();
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    const ticketDetail = getTicketDetailFromStorage();
    const wish = localStorage.getItem("wish");
    const gender = localStorage.getItem("gender");
    const friendGender = localStorage.getItem("friendGender");
    const join = localStorage.getItem("join");

    const isMissingRequired = !ticketDetail || !wish || !gender || !join;
    if (isMissingRequired) return;

    const parsedTicketDetail: TicketDetail = { ...ticketDetail };

    if (
      !parsedTicketDetail.first_name &&
      !parsedTicketDetail.last_name &&
      parsedTicketDetail.user &&
      typeof parsedTicketDetail.user === "object" &&
      "last_name" in parsedTicketDetail.user
    ) {
      parsedTicketDetail.last_name = (
        parsedTicketDetail.user as { last_name?: string }
      ).last_name;
    }

    if (parsedTicketDetail.last_name) {
      parsedTicketDetail.last_name =
        formatLastNameAsInitial(parsedTicketDetail.last_name as string) ?? "";
    }

    if (
      parsedTicketDetail.user &&
      typeof parsedTicketDetail.user === "object" &&
      "last_name" in parsedTicketDetail.user
    ) {
      const user = parsedTicketDetail.user as { last_name?: string };
      if (user.last_name) {
        user.last_name = formatLastNameAsInitial(user.last_name) ?? "";
      }
    }

    const outerFirstName =
      (parsedTicketDetail.first_name as string) ||
      (parsedTicketDetail.user as { first_name?: string })?.first_name ||
      "";
    const outerLastName = (parsedTicketDetail.last_name as string) || "";

    if (outerFirstName || outerLastName) {
      parsedTicketDetail.user_name = `${outerFirstName}${outerFirstName && outerLastName ? " " : ""}${outerLastName}`;
    }

    setTicketDetailInStorage(parsedTicketDetail);

    const statusUpdate = {
      status: "in_use",
      ticketDetail: JSON.stringify(parsedTicketDetail),
      wish,
      gender,
      join,
      friendGender: friendGender || null,
    };

    console.log(JSON.stringify(parsedTicketDetail), "statusUpdate");
    console.log("Emitting updateMakeAWishStatus:", statusUpdate);
    socket.emit("updateMakeAWishStatus", statusUpdate);

    setLatestStatus("in_use");
  }, [socket]);

  useEffect(() => {
    if (!socket) return;

    const handleStatusUpdate = (update: { status?: string }) => {
      if (!update?.status) return;
      setLatestStatus(update.status);
      if (update.status === "free") {
        setTimeout(() => {
          setLatestStatus((current) => {
            if (current === "free") navigate("/");
            return current;
          });
        }, 2000);
      }
    };

    socket.on("makeAWishStatusUpdate", handleStatusUpdate);
    return () => {
      socket.off("makeAWishStatusUpdate", handleStatusUpdate);
    };
  }, [socket, navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 12000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section
      className="magicSection portraitDevice"
    >
      <div className="magicTxtSection">
        <div className="magicTxtHeading">
          See the magic come to <br /> life on the big screen!
        </div>
      </div>
    </section>
  );
};

export default MagicScreen;
